import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AgenticState {
  isOpen: boolean;
  toggle: () => void;
  /** True when any agentic tab has an active run. Synced by useTabsStore.patchTab
   *  so AppHeader can read it without importing the agentic hook chain. */
  isStreaming: boolean;
  setIsStreaming: (v: boolean) => void;
  /** True when ai-processing-status has items actively processing. Synced by
   *  useProcessingStatsSync (mounted in ClientLayout) so AppHeader can read it. */
  isProcessing: boolean;
  processingPercentage: number;
  setProcessingStats: (isProcessing: boolean, percentage: number) => void;
  /** True while bulk-classify is uploading/polling. Synced by useBulkClassify. */
  isClassifying: boolean;
  setIsClassifying: (v: boolean) => void;
  appendToBuilder: ((data: unknown) => void) | null;
  setAppendToBuilder: (fn: ((data: unknown) => void) | null) => void;
  readFromBuilder: (() => unknown) | null;
  setReadFromBuilder: (fn: (() => unknown) | null) => void;
}

export const useAgenticStore = create<AgenticState>()(
  persist(
    set => ({
      isOpen: false,
      toggle: () => set(s => ({ isOpen: !s.isOpen })),
      isStreaming: false,
      setIsStreaming: (v: boolean) => set({ isStreaming: v }),
      isProcessing: false,
      processingPercentage: 0,
      setProcessingStats: (isProcessing, percentage) =>
        set({ isProcessing, processingPercentage: percentage }),
      isClassifying: false,
      setIsClassifying: (v: boolean) => set({ isClassifying: v }),
      appendToBuilder: null,
      setAppendToBuilder: fn => set({ appendToBuilder: fn }),
      readFromBuilder: null,
      setReadFromBuilder: fn => set({ readFromBuilder: fn }),
    }),
    {
      name: 'agentic:panel',
      partialize: s => ({ isOpen: s.isOpen }),
    },
  ),
);
